// Libellés FR + couleur de Tag pour le `reason` d'une ContentVersion.
// Partagé par le panneau d'historique et la vue diff.
const REASON_META = {
  auto: { label: 'Sauvegarde auto', color: 'default' },
  before_pdf: { label: 'Avant génération PDF', color: 'blue' },
  on_open: { label: 'Ouverture du document', color: 'geekblue' },
  before_restore: { label: 'Avant restauration', color: 'orange' },
};

export const reasonLabel = (reason) => REASON_META[reason]?.label ?? reason;
export const reasonColor = (reason) => REASON_META[reason]?.color ?? 'default';
